export const frTranslation = {
  "hotel_info": "Prix et informations de l'hôtel",
  "hotel": {
    "remove_preffered": "Supprimer des préférés",
    "hotel": "Hôtel",
    "s": "Hôtels",
    "found_from": "Hôtels trouvés ",
    "full_cancellation_fee": "Annulation complète",
    "free_cancel_before": "Annulation gratuite avant",
    "show_rooms": "Afficher les chambres",
    "show_all_rooms": "Afficher toutes les chambres",
    "boarding": "La base d'hébergement",
    "refund_limit": "Annulation gratuite",
    "refund_price": "Prix du remboursement",
    "nights": "nuits",
    "rooms": "Chambres",
    "room": "La chambre",
    "room_details": "Détails de la chambre",
    "nights_up": "Nuits",
    "select_room": "Sélectionner votre chambre",
    "filter": "Filtrer...",
    "location": "Emplacement de l'hôtel",
    "book": "Réserver",
    "overview": "Informations générales",
    "facilities": "Services de l'hôtel",
    "details": "Détails de l'hôtel",
    "dates": "Dates",
    "name": "Nom de l'hôtel",
    "non_refundable": "Non remboursable",
    "rooms_prices": "Chambres et prix ({{count}})",
    "desc": "Description de l'hôtel",
    "fac": "Services",
    "gallery": "Galerie",
    "choose_rooms": "Choisir les chambres",
    "single_room": "1 Chambre - {{price}}",
    "multi_rooms": "{{count}} Chambres - {{price}}",
    "rooms_price": "Chambres et prix",
    "paxes": "Composition de la chambre",
    "room_type": "Type de chambre",
    "room_types": "Salle AI",
    "more_room_types": "{{count}} autres types de chambres",
    "description": "Description",
    "address": "Adresse",
    "loc": "Emplacement",
    "hotel_facilities": "Services de l'hôtel",
    "room_facilities": "Services en chambre",
    "please_note": "Veuillez noter !",
    "you_can_choose": "Vous pouvez choisir jusqu'à {{count}} pax",
    "we_suggestion": "Nous avons trouvé d'autres suggestions pour vous",
    "max_rooms": "Veuillez choisir pas plus de {{count}} chambres",
    "max_paxes": "Veuillez choisir pas plus de {{count}} pax",
    "specific_out": "La chambre spécifique est épuisée, voici les alternatives",
    "select_rooms": "Sélectionner les chambres",
    "info": "Infos sur l'hôtel",
    "checking_room_availability": "Vérifier la disponibilité de la chambre...",
    "one_hotel_search_failed": "La chambre choisie n'est pas disponible, veuillez choisir une autre chambre",
    "price_per_night": "Prix par nuit",
    "grp": "Groupe",
    "brd": "Embarquement",
    "bdr": "Chambre",
    "typ": "Type",
    "vew": "Vue",
    "bed": "Lit",
    "ada": "Accessibilité",
    "pax": "Composition de la chambre",
    "cat": "Catégorie",
    "blc": "Balcon",
    "cap": "Capacité",
    "sgl": "Utilisation simple",
    "shr": "Partagé",
    "filter_room_type": "Filtrer pour chambre AI",
    "open_fitler": "Ouvrez",
    "show_room_types": "Affichez les types de chambre",
    "hide_room_types": "Masquez les types de chambre",
    "pay_credit_card": "Payez par carte de crédit",
    "paid_successfully": "Payé avec succès",
    "group_rooms": "Groupez les chambres",
    "ungroup_rooms": "Dissociez les chambres",
    "make_the_rooms_white": "Faire les chambres blanches",
    "make_the_rooms_colored": "Faire les chambres colorées",
    "supplier": "Fournisseur",
    "order_summary": "Récapitulatif de la commande",
    "with_meal": "Avec repas",
    "meal": "Repas",
    "display_settings": "Options d'affichage",
    "room_display": "Affichage de la chambre",
    "clear_room_name": "Effacer le nom de la chambre",
    "filter_rooms": "Filtrer les chambres similaires",
    "our_lowest_prices": "Nos prix les plus bas",
    "show_cube_design": "Afficher le design du cube",
    "show_rooms_in_tab": "Afficher les chambres sous forme d'onglet",
    "show_cube_design_by_eat": "Afficher le design du cube pour l'embarquement",
    "is_short_mode": "Mode liste",
    "company_id": "Company #:",
    "rem_condition": "Observations sur les conditions",
    "remarks": "Observations",
    "backoffice_trip": "BackOffice/Trip# : (0 = nouveau voyage)",
    "cancellation_policy": "Politique d'annulation",
    "sales_price": "Prix de vente",
    "percent": "Pourcentage",
    "amount": "Montant",
    "professional": "Professionnel",
    "client": "Client",
    "professional_single": "Agent - Ligne unique",
    "professional_single_multi": "Agent - Ligne unique (Multi Prix)",
    "professional_single_2": "Agent - Ligne unique par chambre",
    "loca": "Emplacement",
    "professional_v1": "Professionnel V1",
    "professional_v2": "Professionnel V2",
    "professional_v3": "Agent - Base/Catégorie",
    "business_new": "Affaires - Base/Catégorie",
    "price_new": "Affaires - Catégorie/Type",
    "professional_v3_multi": "Agent - Base/Catégorie (Multi Prix)",
    "business_new_multi": "Affaires - Base/Catégorie (Multi Prix)",
    "price_new_multi": "Affaires - Catégorie/Type (Multi Prix)",
    "professional_v4": "Agent - Catégorie/Type",
    "professional_v4_multi": "Agent - Catégorie/Type (Multi Prix)",
    "bussiness": "Affaires",
    "display_mode": "Mode affichage",
    "room_mode": "Mode Chambre",
    "internal": "Interne",
    "tab": "Carte",
    "config_saved": "Configuration enregistrée",
    "room_changed_after_one_hotel_search": "Changement de chambre après la recherche d'un hôtel",
    "get_serialiezed_config": "Obtenir la configuration en série",
    "serialized_config_clipboard": "Configuration sérialisée copiée dans le presse-papiers",
    "center_me": "Centrez-moi",
    "focus": "Centrer",
    "pin_this_item": "Épingler cet élément",
    "room_status": "État de la caméra",
    "about_room": "Informations sur la caméra",
    "room_info": "Informations sur la pièce",
    "preffered": "Préféré",
    "excluded": "Exclus",
    "preferred_saved": "Configuration de l'hôtel préféré sauvegardée",
    "language": "Langue",
    "positive_reviews": "Avis positifs",
    "negative_reviews": "Avis négatifs",
    "price_breakdown": "Détails des prix",
    "non_ref": "Non remboursable",
    "rooms_were_not_found": "Les chambres n'ont pas été trouvées",
    "add_special_request": "Ajouter une demande spéciale",
    "please_add_special_request": "Veuillez ajouter une demande spéciale",
    "sorry_we_cant_find_hotel_here": "Désolé, nous ne trouvons pas l'hôtel ici",
    "we_are_checking_for_better_rates": "Nous recherchons de meilleurs tarifs",
    "we_are_waiting_for_the_chosen_room": "Nous attendons la chambre de votre choix",
    "original_room_description": "Description originale de la chambre",
    "hotel_reservation_in_process": "Réservation actuelle à l'hôtel",
    "number_of_persons": "Numeroe de personnes",
    "search_room": "Recherche de chambre",
    "google": "Google",
    "tripadvisor": "Tripadvisor",
    "monitor": "Moniteur",
    "copy": "Copier",
    "proposal": "Proposition",
    "find_nearly": "Trouver près de",
    "preferred_hotel": "Hôtel préféré",
    "system_recommended": "Système recommandé",
    "travel_agent_recommended": "Agent de voyage recommandé",
    "client_recommended": "Client recommandé",
    "stars": "Étoiles",
    "search": "Recherche en cours",
    "prices": "Prix",
    "rated_by_reviews": "Évalué par {{rating}} avis",
    "reservation_is_refundable": "Cette réservation est remboursable selon les règles de prix/tarif.",
    "reservation_is_not_refundable": "Cette réservation n'est pas remboursable selon les règles de prix/tarif.",
    "choose_up_to_5_cards": "Choisir jusqu'à 5 cartes",
    "multi_payment": "Multi paiements",
    "please_apply_every_price": "Appliquer chaque prix",
    "please_enter_valid_price": "Entrer un prix valide",
    "view_1": "Vue 1",
    "view_2": "Vue 2",
    "display_style": "Style d'affichage",
    "positive_reviews_tags": "Tags de critiques positives",
    "negative_reviews_tags": "Tags de critiques négatives",
    "ai_notes": "Notes de AI",
    "hotel_type": "Type d'hôtel",
    "apartment": "Appartement",
    "villa": "Villa",
    "view_on_website": "Site web de l'hôtel"
  },
  "proposal": {
    "s": "Propositions",
    "remove_proposal": "Supprimer la proposition",
    "max_images_selected": "Vous avez sélectionné le nombre maximum d'images",
    "proposition_removed": "Proposition supprimée",
    "display_order": "Ordre de visualisation",
    "proposal": "Proposition",
    "no": "Pas de proposition",
    "download_pdf": "Télécharger le PDF",
    "send_email": "Envoyer un courriel",
    "create": "Créer une proposition",
    "clear_all": "Supprimer tout",
    "write_comments": "Ecrivez vos commentaires ici...",
    "reviews": "Critiques",
    "created": "La proposition a été créée",
    "show_price": "Montrer le prix",
    "please_select_rooms": "Veuillez sélectionner les chambres",
    "update": "Update",
    "update_all": "Update all",
    "fixed_value": "Fixed value",
    "percentage": "Percentage",
    "edit_price": "Modifier le prix",
    "value": "Valeur",
    "add_to": "Ajouter à la proposition",
    "details": "Détails",
    "amenities": "Aménagements",
    "all_of_images": "Toutes les images",
    "dep": "Dep.",
    "dep_airport": "Dep. Aéroport",
    "arr": "Arr.",
    "arr_airport": "Arr. Aéroport",
    "dynamic": "Dynamique",
    "generated_by_user": "Généré par l'utilisateur",
    "created_at": "Créé le",
    "flight_and_hotel": "Vol et hôtel",
    "google_images": "Informations importantes : les images des hôtels de Google",
    "customize": "Personnaliser",
    "simple_template": "Template simple",
    "colorful_template": "Template coloré",
    "contrast_template": "Template contrasté",
    "room_price_option": "Option de prix de chambre",
    "description": "Description",
    "edit": "Modifier la proposition",
    "some_of_the_products_were_expired": "Certains des produits ont expiré",
    "by_order_id": "Par ordre #",
    "by_service_date": "Par date de service",
    "original": "Original",
    "overwrite_price": "Remplacer le prix",
    "discount_hotel_limit": "Remise du hôtel limit {{minPrice}}",
    "save": "Enregistrer la proposition",
    "whatsapp_message": "Veuillez trouver joint le document de proposition de voyage.",
    "telegram_message": "Veuillez trouver joint le document de proposition de voyage. ",
    "item_view": "Vue article",
    "trip_view": "Vue voyage"
  },
  "map": {
    "list": "Liste",
    "map": "Carte",
    "show": "Afficher la carte"
  },
  "bed_filter": {
    "title": "Filtrer par chambre",
    "pin_only": "Épinglés uniquement"
  },
  "assistant": {
    "tab_tooltip": "Assistant IA",
    "greeting": "Posez une question sur les hôtels ou les vols, par exemple : « vols pour Paris la semaine prochaine » ou « hôtels 5 étoiles avec petit-déjeuner ».",
    "placeholder": "Posez une question sur les hôtels ou les vols…",
    "connecting": "Connexion…",
    "send": "Envoyer",
    "connection_error": "Impossible de se connecter à l'assistant. Veuillez réessayer.",
    "send_error": "Impossible d'envoyer votre message. Veuillez réessayer.",
    "loading": "Chargement…",
    "session": "Session",
    "copy_session_id": "Copier l'ID de session",
    "copied": "Copié",
    "model": "Modèle IA",
    "session_viewer": "Visionneuse de sessions",
    "results_opened": "Les résultats sont sur la page",
    "search_failed": "Impossible d'ouvrir la recherche sur la page. Veuillez réessayer.",
    "widget_title": "Assistant IA",
    "widget_open": "Ouvrir l'assistant IA",
    "widget_close": "Réduire l'assistant IA",
    "widget_new_reply": "Nouvelle réponse de l'assistant IA",
    "voice": {
      "record": "Enregistrer un message vocal",
      "stop": "Envoyer le message vocal",
      "cancel": "Annuler l'enregistrement",
      "recording": "Enregistrement…",
      "mic_denied": "Le microphone est bloqué. Autorisez-le pour ce site dans le navigateur, puis réessayez.",
      "unsupported": "Les messages vocaux ne sont pas pris en charge par ce navigateur.",
      "not_understood": "Je n'ai pas compris le message. Veuillez réessayer.",
      "error": "Impossible de traiter le message vocal. Veuillez réessayer.",
      "limit": "Trop de messages vocaux. Veuillez réessayer plus tard."
    },
    "feedback": {
      "open": "Évaluer cette réponse",
      "sent": "Votre avis a été envoyé. Cliquez pour le modifier",
      "title": "Votre avis",
      "q_understood": "A compris votre demande ?",
      "q_correct": "Informations correctes ?",
      "q_helped": "Vous a aidé à avancer ?",
      "yes": "Oui",
      "no": "Non",
      "placeholder": "Autre chose ? (facultatif)",
      "send": "Envoyer",
      "sending": "Envoi…",
      "thanks": "Merci pour votre avis !",
      "error": "Impossible d'envoyer votre avis. Veuillez réessayer.",
      "close": "Fermer",
    },
    "viewer": {
      "title": "Assistant IA · Visionneuse de sessions",
      "close": "Fermer",
      "company": "Société",
      "department": "Département",
      "branch": "Agence",
      "user": "Utilisateur",
      "status": "Statut",
      "from": "Du",
      "to": "Au",
      "search": "Rechercher",
      "search_placeholder": "ID de session ou mots du chat",
      "all_companies": "Toutes les sociétés",
      "all_departments": "Tous les départements",
      "all_branches": "Toutes les agences",
      "all_users": "Tous les utilisateurs",
      "all_statuses": "Tous les statuts",
      "reset": "Réinitialiser",
      "refresh": "Actualiser",
      "col_started": "Début",
      "col_last": "Dernière activité",
      "col_user": "Utilisateur",
      "col_company": "Société",
      "col_department": "Département",
      "col_branch": "Agence",
      "col_messages": "Messages",
      "col_status": "Statut",
      "col_first_message": "Premier message",
      "empty": "Aucune session ne correspond à ces filtres.",
      "error": "Impossible de charger les sessions. Veuillez réessayer.",
      "forbidden": "Seul le personnel BePro peut ouvrir la visionneuse de sessions.",
      "rows_per_page": "Lignes par page",
      "range": "{{from}}–{{to}} sur {{total}}",
      "prev": "Page précédente",
      "next": "Page suivante",
      "details": "Session",
      "locale": "Langue",
      "search_id": "ID de recherche",
      "tokens": "Tokens",
      "tokens_short": "tokens",
      "feedback_filter": "Avis",
      "col_feedback": "Avis",
      "col_tokens": "Tokens envoyés / reçus",
      "tokens_in_out_hint": "Tokens envoyés au modèle / reçus de celui-ci",
      "feedback_open": "Afficher les avis",
      "feedback_title": "Avis",
      "feedback_open_session": "Ouvrir la session",
      "feedback_empty": "Aucun avis dans cette session.",
      "feedback_like": "Aimé",
      "feedback_dislike": "Pas aimé",
      "feedback_comment": "Commentaire seul",
      "feedback_comment_label": "Commentaire",
      "feedback_no_text": "Pas de commentaire",
      "feedback_q_understood": "Demande comprise",
      "feedback_q_correct": "Informations correctes",
      "feedback_q_helped": "A aidé à avancer",
      "feedback_yes": "Oui",
      "feedback_no": "Non",
      "feedback_unanswered": "—",
      "feedback_question": "Question de l'utilisateur",
      "feedback_answer": "Réponse de l'assistant",
      "feedback_copy": "Copier pour le développeur",
      "feedback_copy_header": "Avis sur l'Assistant IA",
      "feedback_rating": "Évaluation",
      "feedback_date": "Date",
      "conversation": "Conversation",
      "tool_calls": "Appels d'outils",
      "show_tools": "Afficher les appels d'outils",
      "blocked_by_guard": "Bloqué par le garde-fou",
      "failed_calls": "Appels en échec",
      "role_user": "Utilisateur",
      "role_assistant": "Assistant",
      "role_system": "Système",
      "input": "Entrée",
      "error_detail": "Erreur",
      "no_messages": "Cette session ne contient pas encore de messages."
    }
  },
  "close": "Fermer",
  "more": "Plus d'informations",
  "less": "Moins",
  "actions": "Actions",
  "all": "Tous",
  "apply": "Appliquer",
  "apply_2": "Appliquer",
  "choose": "Choisir",
  "from": "de",
  "to": "à",
  "type": "Type",
  "at": "a",
  "km": "km",
  "name": "Prenom",
  "price": "Prix",
  "original_price": "Prix original",
  "reset": "Remise à zéro",
  "continue": "Poursuivi",
  "total": "Total",
  "basis": "Base",
  "taxes": "Frais",
  "back": "Retour",
  "days_sm": "j",
  "hours_sm": "h",
  "minutes_sm": "m",
  "confirm": "Confirmer",
  "title": "Titre",
  "male": "Homme",
  "female": "Féminin",
  "child": "Enfant",
  "success": "Réussite",
  "failed_order": "La commande a échoué. Veuillez appeler pour obtenir de l'aide",
  "error": "Erreur",
  "notes": "Notes",
  "note": "Note",
  "show_less": "Afficher moins",
  "show_more": "Afficher plus",
  "show_all": "Tout afficher",
  "no_entries": "Pas d'entrée",
  "best": "Le meilleur",
  "day": "Jour",
  "ok": "OK",
  "of": "de",
  "add": "Ajouter",
  "save": "Sauver",
  "yes": "Oui",
  "delete": "Supprimer",
  "order_created_successfully": "Commande créée avec succès",
  "session_expired_try_again": "La session a expiré. Veuillez réessayer",
  "cancel": "Annuler",
  "NOFSHON": "Mini-vacances",
  "change_choice": "Modifier le choix",
  "click_here": "Cliquez ici",
  "details": "Détails",
  "clear": "Supprimer",
  "clear_all": "Supprimer tout",
  "REG": "Régulier",
  "pay_wait": "Veuillez patienter...",
  "pay_wait_text": "Votre commande est en cours de traitement",
  "pay_processing": "Traitement du paiement...",
  "normal": "Normal",
  "credit": "Crédit",
  "only_english_input": "Veuillez saisir vos nom et prénom tels qu'ils figurent sur votre passeport.",
  "nights": "nuits",
  "something_went_wrong": "Un problème s'est produit",
  "accessibility": "Accessibilité",
  "payment_error": "Le paiement a échoué.",
  "MultipleDestinations": "Plusieurs villes",
  "RoundTrip": "Aller-retour",
  "OneWay": "Aller simple",
  "eEconomyClass": "Économique",
  "eEconomyPlusClass": "Economie Plus",
  "eBusinessClass": "Business",
  "rules": "Règles",
  "click_for_details": "Cliquez pour les détails",
  "TRAVELFUSION": "LOW",
  "ro": "Chambre seule",
  "bb": "Petit-déjeuner inclus",
  "fb": "Pension complète",
  "ai": "Tout compris",
  "show_cancellation_date": "Afficher la date d'annulation",
  "cancellation_date_delta": "Delta de jours de la date d'annulation",
  "add_to": "Ajouter à la proposition",
  "max_images_selected": "Un maximum de 3 images peut être sélectionné",
  "ai_hotel_info": "Info hôtel IA",
  "claude": {
    "pets": "Animaux de compagnie",
    "cancellation": "Annulation",
    "adults_only": "Adultes uniquement",
    "website": "Site web",
    "notes": "Notes",
    "pros": "Avantages",
    "cons": "Inconvénients",
    "pros_cons": "Avantages et inconvénients",
    "not_found": "L'hôtel n'a pas été trouvé"
  },
  "login": {
    "login": "Se connecter",
    "login_your": "Connectez-vous à votre compte",
    "username": "Prenom d'utilisateur",
    "password": "Mot de passe",
    "success": "Connexion réussie",
    "off_success": "Déconnexion réussie",
    "error": "Prenom d'utilisateur ou mot de passe incorrect",
    "off": "Déconnexion",
    "contact_us": "Contactez-nous",
    "get_back": "Contactez-nous",
    "select_number": "Sélectionnez le numéro de passager",
    "full_name": "Prénom et Nom",
    "contact_us_success": "Votre message a été envoyé avec succès",
    "contact_us_error": "Une erreur s'est produite lors de l'envoi de votre message",
    "as": "Se connecter en tant que",
    "usercode": "Code utilisateur"
  },
  "validation": {
    "numbers": "Seuls les chiffres sont autorisés",
    "email": "Email incorrect",
    "required": "Le champ est obligatoire",
    "minLength": "Le champ doit contenir au moins {1} caractères",
    "maxLength": "Le champ doit contenir {1} caractères ou moins",
    "length": "Le champ doit contenir {1} caractères",
    "english": "Seuls les caractères anglais sont autorisés"
  },
  "mo": {
    "mo": "Mes commandes",
    "segment_gross_edited": "Segment brut modifié avec succès",
    "lock_pnr": "Verrouiller PNR",
    "unlock_pnr": "Déverrouiller PNR",
    "lock_pnr_success": "PNR verrouillé avec succès",
    "unlock_pnr_success": "PNR déverrouillé avec succès",
    "logs": "Journaux",
    "open_log": "Ouvrir le journal",
    "table_settings": "Paramètres du tableau",
    "support_ticket": "Ticket d'assistance",
    "support_ticket_success": "Ticket d'assistance créé avec succès",
    "subject": "Objet",
    "reply": "Répondre",
    "ticket": "Ticket",
    "ticket_updated": "Ticket mis à jour avec succès",
    "segment_id": "Identifiant du segment",
    "order_id": "Id de la commande",
    "order": "Commande",
    "local": "Local",
    "supplier_pnr": "PNR du fournisseur",
    "backoffice_id": "Id du backoffice",
    "passenger_name": "Prénom du passager",
    "creation_date": "Date de création",
    "orders": "Commandes",
    "segment": "Seg.",
    "segment_full": "Segment",
    "docket": "Document",
    "pnr": "PNR",
    "start": "Début",
    "name": "Nom",
    "dest": "Dest.",
    "items": "Entrées",
    "clx": "CLX",
    "status": "S",
    "voucher": "V",
    "quantity": "Q",
    "total": "Total",
    "pay": "P",
    "supplier": "S",
    "end": "C",
    "agent": "Agent",
    "branch": "Branche",
    "order_details": "Détails de la commande",
    "check_in": "Arrivée",
    "check_out": "Départ",
    "nights": "Nuits",
    "date_c": "Date C",
    "segment_details": "Détails du segment",
    "paxes": "P.",
    "legs": "T.",
    "class": "C.",
    "date_time": "Date et heure",
    "arrival": "Arrivée",
    "status_full": "Statut",
    "pnr_ref": "Réf. PNR",
    "supplier_full": "Fournisseur",
    "emergency_phone": "Téléphone d'urgence",
    "support_email": "E-mail d'assistance",
    "emergency_email": "E-mail d'urgence",
    "amount": "Montant",
    "gross": "Brut",
    "coupon_code": "Code du coupon",
    "total_gross": "Total brut",
    "total_net": "Total net",
    "disc_coupon": "Dis. Cupon",
    "vat": "TVA",
    "total_due": "Total dû",
    "client_id": "Code client",
    "discount": "Remise",
    "comission": "Commission",
    "profit": "Bénéfice",
    "remarks": "Remarques",
    "remark": "Remarque",
    "info": "Info",
    "remark_code": "Code",
    "order_seg_remark_id": "ID de l'observation",
    "desc": "Message",
    "user": "Utilisateur",
    "dateC": "Date C",
    "depatment": "Département",
    "voucher_full": "Bon d'échange",
    "print_voucher": "Impression du bon",
    "voucher_number": "Numéro du bon",
    "backoffice_voucher_identity_number": "Numéro d'identité du backoffice du bon",
    "status_the_same": "Le statut est le même",
    "status_changed": "Le statut a été modifié en {{status}}",
    "current_status": "Statut actuel",
    "product_type": "Type de produit",
    "back_to_orders": "Retour aux commandes",
    "cancel_order": "Annulation de commande",
    "segments": "Segments",
    "booking_about_to_cancel": "Cette réservation est sur le point d'être annulée.",
    "are_you_sure": "En êtes-vous sûr ?",
    "order_cancelled": "Votre commande a été annulée avec succès. L'état a été modifié en {{status}}.",
    "hello": "Bonjour",
    "user_code": "Code utilisateur",
    "department": "Département",
    "loading": "Chargement...",
    "supp": "Fournisseur",
    "pnr_to_docket": "PNR dans le dossier",
    "docket_success": "Le document a été sauvegardé avec succès",
    "clipboard_success": "Données copiées dans le presse-papiers",
    "no_data_found": "Aucune donnée trouvée",
    "room_preferences": "Préférences de chambre",
    "guest_notes": "Notes de l'invité",
    "additional_requirements": "Exigences supplémentaires",
    "please_double_bed": "Si possible, veuillez confirmer une chambre avec un <b>lit double</b>",
    "please_twin_beds": "Si possible, veuillez confirmer une chambre avec <b>deux lits simples</b>",
    "please_high_floor": "Si possible, veuillez confirmer une chambre à un <b>étage élevé</b>",
    "please_low_floor": "Si possible, veuillez confirmer une chambre à un <b>étage bas</b>",
    "please_non_smoking": "Si possible, veuillez confirmer une chambre <b>non-fumeur</b>",
    "please_smoking": "Si possible, veuillez confirmer une chambre <b>fumeur</b>",
    "please_adjoining_room": "Si possible, veuillez confirmer une chambre <b>communicante</b>",
    "please_connecting_rooms": "Si possible, veuillez confirmer des <b>chambres communicantes</b>",
    "please_quiet_room": "Si possible, veuillez confirmer une chambre <b>calme</b>",
    "please_bathtub": "Si possible, veuillez confirmer une chambre avec une <b>baignoire</b>",
    "please_accessible_room": "Si possible, veuillez confirmer une chambre <b>accessible</b> ou <b>adaptée aux personnes handicapées</b> avec une <b>douche à accès plain-pied</b> (le client utilise un fauteuil roulant)",
    "note_late_arrival": "Veuillez noter que l'invité arrivera <b>tard (après 19h00)</b>",
    "confirm_early_arrival": "Veuillez confirmer l'<b>arrivée anticipée</b> vers : ______",
    "confirm_late_arrival": "Veuillez confirmer l'<b>arrivée tardive</b> vers : ______",
    "confirm_late_checkout": "Veuillez confirmer le <b>départ tardif</b> vers : ______",
    "note_no_voucher": "Veuillez noter : <b>l'invité arrivera sans bon</b>",
    "note_honeymoon": "Veuillez noter : <b>les passagers sont en lune de miel</b>",
    "confirm_baby_cot": "Si possible, veuillez confirmer un <b>lit bébé</b> pour :<br>Nom complet du nourrisson : {{fullName}} Date de naissance : {{dob}}",
    "add_confirm_baby_cot": "Veuillez ajouter un bébé à la chambre, si possible, et confirmer un lit bébé pour lui : nom complet : {{fullName}} Date de naissance : {{dob}}",
    "if_child": "Ceci est si le bébé est dans la commande",
    "if_no_child": "Si le bébé n'est pas dans la commande",
    "please_enter_info_about_baby": "Veuillez saisir les informations sur le bébé",
    "change_request": "Demande spéciale",
    "change_request_success": "Demande spéciale envoyée avec succès",
    "choose_requests_can_edit": "Veuillez choisir une ou plusieurs demandes dans la liste. Vous pouvez modifier le texte de la demande ici.",
    "order_information": "Commande - Information",
    "order_public_price": "Commande - Prix public",
    "order_send_order_email": "Commande - Envoi de la commande par courriel",
    "order_agent": "Commande - Agent",
    "order_operator": "Commande - Opérateur",
    "print": "Imprimez",
    "send": "Envoyez",
    "print_file_generated": "Le fichier a été créé avec succès.",
    "documents": "Documents",
    "file_name": "Nom du fichier",
    "file_type": "Type de fichier",
    "tran_id": "ID de la transaction",
    "ptr_id": "ID PTR",
    "reason": "Motif",
    "token": "Jeton",
    "p": "P",
    "a": "A",
    "t": "T",
    "err_code": "Code d'erreur",
    "payments": "Paiements",
    "order_report": "Rapport de commande",
    "order_report_sent_success": "Rapport de commande envoyé avec succès",
    "send_to_me": "Envoyez-moi un e-mail {{email}}",
    "thin_report": "Rapport fin",
    "email_success": "Courriel envoyé avec succès",
    "voucher_type": "Type de bon",
    "regular_voucher": "Bon ordinaire",
    "thin_voucher": "Bon mince",
    "display_order": "Voir la commande",
    "issue_voucher": "Émission du bon",
    "copied": "Texte enregistré dans le presse-papiers",
    "link_copied": "Lien copié dans le presse-papiers",
    "send_support_message": "Envoyer un message d'assistance",
    "send_support_message_success": "Message d'assistance envoyé avec succès",
    "add_comission": "Ajouter une commission",
    "item": "Article",
    "search_again": "Rechercher à nouveau",
    "download_success": "Téléchargement réussi",
    "units": "Unités",
    "order_list_report": "Rapport de liste de commandes",
    "order_list_report_no_names": "Rapport de liste de commandes - Sans noms",
    "order_list_report_by_param": "Rapport de liste de commandes par paramètre",
    "order_list_report_by_dest": "Rapport de liste de commandes par destination",
    "summary_report_by_department": "Rapport récapitulatif par département",
    "summary_report_by_branch": "Rapport récapitulatif par agence",
    "summary_report_by_supplier": "Rapport récapitulatif par fournisseur",
    "orders_by_branch": "Commandes par agence",
    "orders_by_currency": "Commandes par devise",
    "orders_by_supplier": "Commandes par fournisseur",
    "export_to_file": "Exporter vers un fichier",
    "export_to_file_no_names": "Exporter vers un fichier - Sans noms",
    "export_to_file_refund": "Exporter vers un fichier - Remboursement",
    "refund_report": "Rapport de remboursement",
    "coupon_report": "Rapport de coupons",
    "report_price": "Prix du rapport",
    "public_price": "Prix public",
    "sys_total_agent": "Total système - Agent",
    "sys_nett_operator": "Système net - Opérateur",
    "report_type": "Type de rapport",
    "report": "Rapport",
    "report_generated": "Rapport généré avec succès",
    "currency": "Devise",
    "tour_subject": "Sujet du tour",
    "add_remark": "Ajouter une remarque",
    "remark_added": "Remarque ajoutée avec succès",
    "ticket_number": "Numéro de billet",
    "public": "Public",
    "private": "Privé",
    "body": "Corps",
    "support_update": "Mettre à jour le ticket",
    "support_update_success": "Ticket mis à jour avec succès",
    "itinerary": "Itinéraire",
    "include": "Inclus",
    "not_included": "Non inclus",
    "information": "Information",
    "start_price": "À partir de",
    "change_user": "Changer l'utilisateur",
    "change_user_success": "Utilisateur changé avec succès",
    "current_user": "Utilisateur actuel",
    "data_saved": "Données sauvegardées avec succès",
    "agency": "Agence",
    "currencies": "Devises",
    "upload_logo": "Télécharger le logo",
    "current_logo": "Logo actuel",
    "new_logo": "Nouveau logo",
    "last_update": "Dernière mise à jour",
    "download": "Télécharger",
    "documents_uploaded_successfully": "{{count}} documents téléchargés avec succès",
    "no_files_selected": "Aucun fichier sélectionné",
    "choose_files": "Choisir des fichiers",
    "delete_document": "Supprimer le document",
    "document_deleted": "Document supprimé avec succès",
    "all_departments": "Tous les départements",
    "all_branches": "Toutes les agences",
    "profile": "Profil",
    "set_different_user": "Définir un utilisateur différent",
    "login_as": "Se connecter en tant que",
    "username": "Nom d'utilisateur",
    "reset": "Réinitialiser",
    "logged_as_user_successfully": "Connecté en tant que utilisateur avec succès",
    "logged_as_user_reset_successfully": "Déconnecté en tant que utilisateur avec succès",
    "add_payment": "Ajouter un paiement"
  },
  "destination": {
    "s_our_top": "Nos destinations recommandées"
  },
  "search": {
    "new": "Nouvelle recherche",
    "remember_mode_enabled": "Mode de recherche activé",
    "open_details_in_new_tab": "Ouvrir les détails dans un nouvel onglet",
    "your_latest_searches": "Vos dernières recherches",
    "radius": "Rayon",
    "no_results": "Aucun résultat trouvé",
    "destination": "Destination",
    "check_in": "Arrivée",
    "check_out": "Départ",
    "max_occupancy": "Occupation maximale",
    "rooms": "Chambres",
    "room": "Chambre",
    "star_rating": "Étoiles",
    "nationality": "Nationalité",
    "adults": "Adultes",
    "children": "Enfants",
    "youths": "Jeunes",
    "seniors": "Personnes âgées",
    "infants": "Bébés",
    "adult": "Adulte",
    "child": "Enfant",
    "youth": "Jeune",
    "senior": "Personne âgée",
    "infant": "Nourrisson",
    "under": "jusqu'à",
    "add_room": "Ajouter une chambre",
    "search": "Recherche",
    "max_persons": "Nombre maximum de personnes : {{count}}",
    "infants_warning": "Le nombre de nourrissons doit être inférieur au nombre d'adultes.",
    "history": "Historique de la recherche",
    "age": "Âge des enfants (2-16)",
    "suppliers": "Fournisseurs",
    "with_active_filters": "Conserver les filtres",
    "display_exactly": "Afficher exactement",
    "search_type_id": "ID du type de recherche"
  },
  "sort": {
    "er": "Trier",
    "by": "Trier par",
    "price_increase": "Prix : du plus bas au plus haut",
    "price_decrease": "Prix : du plus élevé au plus bas",
    "cxl_increase": "CXL: du plus bas au plus haut",
    "cxl_decrease": "CXL: du plus haut au plus bas",
    "airline_increase": "Compagnie aérienne : (A - Z)",
    "airline_decrease": "Compagnie aérienne : (Z - A)",
    "star_increase": "Étoile : du plus bas au plus haut",
    "star_decrease": "Étoile : du plus haut au plus bas",
    "hotel_increase": "Nom de l'hôtel : (A - Z)",
    "hotel_decrease": "Nom de l'hôtel : (Z - A)",
    "duration_increase": "Durée : de basse à haute",
    "duration_decrease": "Durée : de haut en bas",
    "departure_outbound_increase": "Décollage le plus tôt ({{dep}})",
    "departure_outbound_decrease": "Dernier décollage ({{dep}})",
    "returning_outbound_increase": "Atterrissage le plus tôt ({{arr}})",
    "returning_outbound_decrease": "Dernier atterrissage ({{arr}})",
    "departure_inbound_increase": "Décollage le plus précoce ({{arr}})",
    "departure_inbound_decrease": "Dernier décollage ({{arr}})",
    "returning_inbound_increase": "Atterrissage le plus précoce ({{dep}})",
    "returning_inbound_decrease": "Dernier atterrissage ({{dep}})",
    "recommended": "Recommandé",
    "distance": "Distance",
    "distance_increase": "Distance : (0 - 100)",
    "distance_decrease": "Distance : (100 - 0)",
    "name": "Nom",
    "star": "Étoile"
  },
  "group": {
    "gr": "Groupe",
    "special": "Spécial",
    "group": "Demande spéciale",
    "request": "Demande spéciale",
    "request_type": "Type de demande",
    "hotel": "Hôtel",
    "flight": "Vol",
    "destination": "Destination",
    "hotel_name": "Nom de l'hôtel",
    "room_type": "Type de chambre",
    "double": "Double",
    "single": "Simple",
    "triple": "Triple",
    "quadro": "Quadruple",
    "group_type": "Type de demande",
    "hotel_stars": "Étoiles de l'hôtel",
    "stars_5": "5 étoiles",
    "stars_4": "4 étoiles",
    "stars_3": "3 étoiles",
    "stars_2": "2 étoiles",
    "star_1": "1 étoile",
    "number_of_rooms": "Numero de chambres",
    "check_in": "Arrivée",
    "check_out": "Départ",
    "contact_information": "Informations de contact",
    "agency_name": "Nom de l'agence",
    "agent_fn": "Prénom de l'agent",
    "agent_ln": "Nom de l'agent",
    "agent_email": "Courriel de l'agent",
    "agent_phone": "Téléphone de l'agent",
    "message": "Message",
    "send_request": "Envoyer la demande",
    "request_sent": "Demande envoyée avec succès",
    "from": "De",
    "to": "À",
    "date": "Date",
    "flight_time": "Heure du vol",
    "airline": "Compagnie aérienne",
    "number_of_passengers": "Numero de passagers"
  },
  "filter": {
    "filter": "Filtre",
    "free_text": "Texte libre",
    "s": "Filtres",
    "stops": "Escales",
    "stop": "escale",
    "stop_up": "Escale",
    "stops_sm": "escales",
    "direct_flight": "Vols directs uniquement",
    "direct_flights": "Vols directs uniquement",
    "direct_flights_outbound": "Vols directs au départ",
    "one_stop": "1 escale",
    "two_or_more_stops": "2+ escales",
    "reset": "Réinitialiser les filtres",
    "price_range": "Fourchette de prix",
    "times": "Horaires",
    "takeoff": "Décollage",
    "landing": "Atterrissage",
    "duration": "Durée",
    "stop_duration": "Durée de l'escale",
    "airlines": "Compagnies aériennes",
    "airports": "Aéroports",
    "by_name": "Nom",
    "by_rooms": "Chambres",
    "by_stars": "Étoiles",
    "by_prices": "Prix",
    "search_by_location": "Rechercher par emplacement",
    "more": "Plus de filtres...",
    "free_cancellation": "Annulation gratuite",
    "board": "Pension",
    "clear": "Effacer les filtres",
    "baggage": "Bagages",
    "baggage_included": "Bagages inclus",
    "baggage_not_included": "Bagages non inclus",
    "meal": "Repas",
    "airline": "Compagnie aérienne",
    "free_x": "Gratuit",
    "is_less_than": "Inférieur à",
    "is_greater_than": "Supérieur à",
    "free": "Gratuit X",
    "preffered_hotels": "Hôtels préférés",
    "breakfast": "Petit-déjeuner",
    "half_board": "Demi-pension",
    "full_board": "Pension complète",
    "all_inclusive": "Tout compris",
    "max_price": "Max prix",
    "min_price": "Min prix",
    "max": "Max",
    "min": "Min"
  },
  "home": {
    "home": "Accueil",
    "session_expired": "Session expirée",
    "session_expired_desc": "Votre session a expiré. Essayez de rechercher à nouveau",
    "go_back": "Retour à l'accueil",
    "search_out_of_date": "Les résultats de votre recherche sont peut-être périmés",
    "please_refresh": "Actualiser les résultats de la recherche",
    "refresh_results": "Actualiser les résultats",
    "new_search": "Nouvelle recherche",
    "confirmation_dialog": "Dialogue de confirmation",
    "password": "Mot de passe",
    "wrong_password": "Mot de passe erroné",
    "failed_to_pay": "Impossible de créer la commande, la commande a été annulée pendant le processus de réservation. Veuillez réessayer"
  },
  "passenger": {
    "as_client": "En tant que client",
    "as_agent": "En tant qu'agent",
    "details": "Détails sur le passager",
    "important_notes": "Notes importantes",
    "apartment_notes": "Veuillez noter : La réception n'est pas disponible dans certains appartements. L'enregistrement se fait en ligne et les codes d'accès sont envoyés à l'avance.",
    "passenger": "Passager",
    "s": "Passagers",
    "guest": "Invité",
    "guests": "Invités",
    "gender": "Sexe",
    "male": "Homme",
    "female": "Féminin",
    "ln": "Nom",
    "fn": "Prénom",
    "dob": "Date de naissance",
    "phone": "Téléphone",
    "email": "Adresse électronique",
    "confirm": "Veuillez confirmer que vous acceptez les conditions",
    "read_more": "Plus d'informations",
    "attention": "Attention ! Votre réservation est déjà en politique de pénalité",
    "order_details": "Détails de la commande",
    "cancellation_details": "Détails de l'annulation",
    "cancellation_date": "Vous pouvez annuler votre commande au plus tard le",
    "cancellation_outdate": "Ne peut pas être annulé. Frais d'annulation complets",
    "booking_summary": "Résumé de la réservation",
    "room_count": "Nombre de chambres",
    "confirm_order": "Confirmer la commande",
    "room": "Chambre",
    "optional_services": "Services optionnels (bagages et repas)",
    "methods_of_payment": "Moyens de paiement",
    "fast_secure": "Paiement rapide et sécurisé par carte de crédit",
    "transaction_type": "Type de transaction",
    "number_of_payments": "Nombre de versements",
    "send_request_to_consultant": "Envoyer une demande au conseiller en voyages",
    "green_button_tooltip": "Vous préférez payer à l'un de nos représentants ? Appuyez sur le bouton vert pour réserver votre place et un représentant vous appellera sous peu.",
    "send_request": "Envoyer la demande",
    "rule_display": "Affichage de la règle",
    "rule_i": "Règle {{i}}. {{fareBase}} | {{airlineCode}} | {{departureCode}}-{{arrivalCode}}",
    "message": "Message",
    "birthday": "Anniversaire",
    "years": "Années",
    "confirm_order_text": "Confirmer la commande de réservation",
    "mr": "Monsieur",
    "mrs": "Mme",
    "miss": "Mlle",
    "ms": "Mme.",
    "dr": "Dr.",
    "prof": "Prof.",
    "title": "Titre",
    "phone_country": "Indicatif pays",
    "add": "Ajouter un passager",
    "passport_valid_till": "Passeport valide jusqu'au",
    "passport": "Passeport",
    "price_for_single_in_composition_for_double": "Prix pour simple en composition pour double",
    "order_id": "ID de commande",
    "id_number": "Numéro d'identification",
    "cancel_order_success": "Envoyé avec succès",
    "city": "Ville",
    "branch_title": "Titre de la branche",
    "display_cancellation_policy": "Afficher la politique d'annulation",
    "please_wait": "Veuillez patienter...",
    "your_payment_is_being_processed": "Votre paiement est en cours de traitement",
    "fast_secure_multi_payment": "Paiement rapide et sécurisé avec jusqu'à {{count}} cartes de crédit",
    "procces_with_revolut": "Traiter avec Revolut",
    "pay": "Payer",
    "every_hotel_has_room": "Chaque hôtel doit avoir une chambre"
  },
  "access": {
    "accessibility_settings": "Paramètres d'accessibilité",
    "internet_accessibility": "L'accessibilité à l'internet signifie que les personnes handicapées peuvent utiliser l'internet.",
    "contrast": "Contraste",
    "dark": "Foncé",
    "normal": "Normal",
    "bright": "Clair",
    "color": "Couleur",
    "high": "Haute",
    "black_white": "Noir et blanc",
    "font_size": "Taille de la police",
    "clear_selection": "Effacer la sélection"
  },
  "deal": {
    "tours": "Circuits",
    "fly_drive": "Fly Drive",
    "nofshon": "Forfait touristique",
    "ski": "Ski",
    "spa": "Spa",
    "sport": "Sport",
    "cruise": "Croisière"
  },
  "cookie": {
    "cookie_policy": "Politique des cookies",
    "title": "Nous respectons votre vie privée.",
    "text": "Nous utilisons des cookies pour améliorer votre expérience de navigation, servir des publicités personnalisées ou du contenu, et analyser notre trafic. En cliquant sur \"Accepter tout\", vous consentez à l'utilisation de cookies.",
    "accept": "Accepter tout",
    "reject": "Rejeter tout"
  }
};
